import React, { useState, useMemo, useCallback } from 'react';
import { ThemeProvider, createTheme, CssBaseline, Container } from '@mui/material';
import DirectoryView from './components/DirectoryView';

function getInitialDarkMode(): boolean {
  try {
    const stored = localStorage.getItem('darkMode');
    if (stored !== null) return stored === 'true';
    return window.matchMedia?.('(prefers-color-scheme: dark)').matches ?? false;
  } catch {
    return false;
  }
}

function App() {
  const [darkMode, setDarkMode] = useState<boolean>(getInitialDarkMode);

  const toggleDarkMode = useCallback(() => {
    setDarkMode(prev => {
      const next = !prev;
      try {
        localStorage.setItem('darkMode', String(next));
      } catch {
        // storage unavailable; state still toggles in memory
      }
      return next;
    });
  }, []);

  const theme = useMemo(() => createTheme({
    palette: {
      mode: darkMode ? 'dark' : 'light',
      primary: {
        main: '#1976d2',
      },
      secondary: {
        main: '#dc004e',
      },
    },
    typography: {
      fontFamily: 'monospace',
    },
  }), [darkMode]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Container>
        <DirectoryView darkMode={darkMode} toggleDarkMode={toggleDarkMode} />
      </Container>
    </ThemeProvider>
  );
}

export default App;
